export const SLIDER_SETTINGS = {
	arrows: true,
	vertical: false,
	speed: 500,
	style: {
		height: 400
	},
	infinite: false,
	lazyLoad: false,
	slidesToShow: 5,
	slidesToScroll: 4,
}

export const MOBILE_SLIDER_SETTINGS = {
	vertical: false,
	speed: 500,
	swipeToSlide: true,
	style: {
		height: 100
	},
	infinite: false,
	lazyLoad: true,
	slidesToShow: 4,
	slidesToScroll: 1
}
